// polyfills based on https://lit.dev/docs/tools/requirements/#loading-polyfills
import "core-js/stable"
import "regenerator-runtime/runtime"

import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js'
import 'lit/polyfill-support.js'
import '@webcomponents/webcomponentsjs/webcomponents-loader.js'

import * as Sentry from '@sentry/browser';

// error reporting
const sentryOptions = {
    integrations: [
        Sentry.reportingObserverIntegration({
            types: ['crash', 'intervention']
        }),
        Sentry.httpClientIntegration()
    ],
    ...SENTRY.config
};
Sentry.init(sentryOptions);

import('./main');
